import {
  getStatsColumnMapping,
  stats_columns_mapping,
} from "../utils/columnsJsonInformation";

export function get_actual_stat_name(
  display_name,
  league,
  remoteConfig = null
) {
  if (league != null) {
    const returnColumn = getStatsColumnMapping(league, remoteConfig).filter(
      (column) => column.display_name == display_name
    );
    return returnColumn[0].actual_name;
  }
}

export const lineupData = [
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      {
        player_name: "Kane Williamson",
        position: "BA",
        salary: 9.0,
        fppg: 25.0,
      },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
      { player_name: "Vijay Shankar", position: "AR", salary: 8.5, fppg: 32.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.5,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      {
        player_name: "Kane Williamson",
        position: "BA",
        salary: 9.0,
        fppg: 25.0,
      },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Anuj Rawat", position: "WK", salary: 8.0, fppg: 32.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.0,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Abdul Samad", position: "BA", salary: 8.0, fppg: 24.0 },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Anuj Rawat", position: "WK", salary: 8.0, fppg: 32.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 98.0,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Abdul Samad", position: "BA", salary: 8.0, fppg: 24.0 },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
      { player_name: "Vijay Shankar", position: "AR", salary: 8.5, fppg: 32.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 98.5,
  },
  {
    players: [
      {
        player_name: "Kane Williamson",
        position: "BA",
        salary: 9.0,
        fppg: 25.0,
      },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Abdul Samad", position: "BA", salary: 8.0, fppg: 24.0 },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
      { player_name: "Vijay Shankar", position: "AR", salary: 8.5, fppg: 32.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.5,
  },
  {
    players: [
      {
        player_name: "Kane Williamson",
        position: "BA",
        salary: 9.0,
        fppg: 25.0,
      },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Abdul Samad", position: "BA", salary: 8.0, fppg: 24.0 },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Anuj Rawat", position: "WK", salary: 8.0, fppg: 32.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.0,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      {
        player_name: "Kane Williamson",
        position: "BA",
        salary: 9.0,
        fppg: 25.0,
      },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Kartik Tyagi",
        position: "BO",
        salary: 8.0,
        fppg: 29.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.0,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Riyan Parag", position: "BA", salary: 8.5, fppg: 21.0 },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Anuj Rawat", position: "WK", salary: 8.0, fppg: 32.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 98.5,
  },
  {
    players: [
      {
        player_name: "Kane Williamson",
        position: "BA",
        salary: 9.0,
        fppg: 25.0,
      },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Riyan Parag", position: "BA", salary: 8.5, fppg: 21.0 },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Anuj Rawat", position: "WK", salary: 8.0, fppg: 32.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.5,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      { player_name: "David Miller", position: "BA", salary: 9.0, fppg: 21.0 },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Anuj Rawat", position: "WK", salary: 8.0, fppg: 32.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.0,
  },
  {
    players: [
      { player_name: "Kedar Jadhav", position: "BA", salary: 8.0, fppg: 25.0 },
      { player_name: "David Miller", position: "BA", salary: 9.0, fppg: 21.0 },
      {
        player_name: "Manish Pandey",
        position: "BA",
        salary: 9.0,
        fppg: 50.0,
      },
      { player_name: "Rashid Khan", position: "BO", salary: 9.5, fppg: 39.0 },
      {
        player_name: "Mustafizur Rahman",
        position: "BO",
        salary: 8.5,
        fppg: 95.0,
      },
      {
        player_name: "Sandeep Sharma",
        position: "BO",
        salary: 8.5,
        fppg: 40.0,
      },
      {
        player_name: "Jonny Bairstow",
        position: "WK",
        salary: 10.0,
        fppg: 46.0,
      },
      { player_name: "Sanju Samson", position: "WK", salary: 9.5, fppg: 66.0 },
      { player_name: "Jos Buttler", position: "WK", salary: 9.5, fppg: 177.0 },
      { player_name: "Chris Morris", position: "AR", salary: 9.5, fppg: 107.0 },
      { player_name: "Vijay Shankar", position: "AR", salary: 8.5, fppg: 32.0 },
    ],
    aggregated_stats: {
      OperatorPlayerCredits: 0,
      Dream11ValueSeason: 0,
      Dream11ValueLast4Games: 0,
      OperatorBetsMade: 0,
      OperatorPlayerFantasyPoints: 0,
      AvgTotalFP: 0,
      Avg4WTotalFP: 0,
      Dream11ProjectedCeilFantasyPoints: 0,
      Dream11ProjectedFloorFantasyPoints: 0,
      Dream11ProjectedValue: 0,
      Dream11ProjectedFantasyPoints: 0,
    },
    salary_costs: 99.5,
  },
];
